import { makeStyles } from "@material-ui/core";
import { h5Medium, h6Medium, h7Regular } from "../../../shared/typography";
import { pointer } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  form: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  // `display: contents` makes the fieldset generate no layout box of its
  // own, so `form`'s flex-column layout applies directly to its children —
  // fieldsets have a browser quirk where they don't reliably participate as
  // a sized flex container/item themselves (child percentage heights and
  // flex-grow distribution don't resolve correctly against them). The
  // `disabled` attribute still propagates to descendant form controls
  // regardless, since that's an HTML/DOM behavior, not a layout one.
  fieldset: {
    border: "none",
    margin: 0,
    padding: 0,
    minWidth: 0,
    display: "contents",
  },
  // Absorbs any leftover vertical space so the submit button sticks to the
  // bottom of the (fixed-height) modal regardless of how few fields/links
  // precede it, while the button's own marginTop still guarantees a minimum
  // gap when content already fills the available height.
  spacer: {
    flex: 1,
  },
  // Applied alongside the global "h6-regular" class so the input/label text
  // steps down to the smaller mobile type scale, matching the h6→h7 pattern
  // used elsewhere (e.g. DeliveryCard.styles.tsx) — "h6-regular" itself is a
  // fixed-size global CSS class with no responsive behavior of its own.
  fieldFont: {
    "@media (max-width:940px)": {
      ...h7Regular,
    },
  },
  // The global ".form-input" CSS hardcodes `color: grey` for the typed
  // value, which reads as washed-out/unconfident. Match the rest of the
  // app's text treatment instead (dark navy at reduced opacity, not a flat
  // grey) — this only needs to win over ".form-input" by JSS injection
  // order, so it doesn't need `!important`.
  fieldInputText: {
    color: "#15222F",
    opacity: 0.64,
  },
  passwordGroup: {
    marginTop: 45,

    "@media (max-width:940px)": {
      marginTop: 32,
    },
  },
  passwordToggle: {
    position: "absolute",
    right: 12,
    top: 10,
    color: "#15222F",
    opacity: 0.8,
    ...pointer,
  },
  disabledLink: {
    opacity: 0.4,
    cursor: "default",
  },
  // Row wrapper handles the alignment; the link itself stays inline so its
  // clickable area is only as wide as its text (a full-width flex span meant
  // clicking the empty space beside it also navigated to forgot-password).
  forgotRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 4,
  },
  forgotLink: {
    ...h7Regular,
    color: "#80BB34",
    ...pointer,
  },
  button: {
    height: 56,
    width: "100%",
    border: "none",
    textAlign: "center",
    background: "#80BB34",
    borderRadius: 16,
    marginTop: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...h5Medium,
    color: "#FFFFFF",
    ...pointer,
    "&:disabled": {
      opacity: 0.5,
      cursor: "default",
    },

    "@media (max-width:940px)": {
      height: 48,
      marginTop: 32,
      ...h6Medium,
      color: "#FFFFFF",
    },
  },
  emailSentMessage: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    ...h6Medium,
    color: "#80BB34",
  },
}));
